import { Dialog, Divider, Grid, Typography, Stack, Paper } from '@mui/material';
import { ButtonPrimary } from 'components/ui/Button/Button';
import PdfViewer from 'components/ui/Common/PdfViewer';
import { useHttpClient } from 'hooks';
import { neutral } from 'lib/mui/colors';
import * as React from 'react';
import { MappedEntityType, Entity } from 'services/resolvers';
import { OwnUserWithCompany } from 'services/resolvers/Common';
import { FullUser } from 'services/resolvers/Users';

export type ForceAgreementProps = {
    user: OwnUserWithCompany | FullUser;
};

const ForceAgreement = ({ user: { pendingAgreement } }: ForceAgreementProps) => {
    const { asyncDetachedRequest } = useHttpClient(Entity.Generic, MappedEntityType.SignAgreement, null, 'Agreement signed');
    const [open, setOpen] = React.useState(!!pendingAgreement);

    const submitAgreement = async () => {
        const ip = await fetch('https://api.ipify.org?format=json')
            .then((res) => res.json())
            .catch(() => ({ ip: 'unknown' }));

        asyncDetachedRequest({
            body: {
                agreementId: pendingAgreement?.id,
                site: window.location.hostname,
                client: navigator.userAgent,
                ip: ip.ip
            }
        }).then(() => setOpen(false));
    };

    return (
        <Dialog open={open} maxWidth="lg" PaperProps={{ sx: { overflowY: 'hidden' } }} disableEscapeKeyDown>
            <Grid container width="50vw" height="100vh" p={3} pt={1} alignContent="flex-start">
                <Grid item xs={12}>
                    <Stack justifyContent="space-between" direction="row">
                        <Typography variant="h2">{pendingAgreement?.name}</Typography>
                        <ButtonPrimary onClick={submitAgreement}>Sign and accept agreement</ButtonPrimary>
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    <Divider sx={{ my: 1, borderColor: neutral[400] }} />
                </Grid>
                <Grid item xs={12} pt={2}>
                    <Paper sx={{ pt: 1, width: 1, height: '80vh', overflow: 'auto' }}>
                        <PdfViewer fileUrl={pendingAgreement?.fileUrl || ''} showFullscreen={false} />
                    </Paper>
                </Grid>
            </Grid>
        </Dialog>
    );
};

export default ForceAgreement;
